
const ellipsis = function(value) {
  if (!value) return ''
  if (value.length > 35) {
    return value.slice(0,35) + '...'
  }
  return value
}


const _filters = {
  ellipsis
};

export default _filters;
